export function $icon(name) {
    return name;
}
//# sourceMappingURL=icon-sprite.js.map